import {
  ConsultationReimbursementReport,
  ReimbursementReportData,
} from "../utils/types/consultation";
import { api } from "./axios";

const getReimbursementReportUrl = (consultationId?: string) =>
  `/v1/team-members/consultations/${consultationId}/reimbursement-reports`;

export const createReimbursementReport = async (
  zoomMeetingId: string,
  consultationId?: string,
) => {
  const { data } = await api.post<ConsultationReimbursementReport>(
    getReimbursementReportUrl(consultationId),
    { zoom_meeting_id: zoomMeetingId },
  );
  return data;
};

export const getReimbursementReport = async (consultationId?: string) => {
  const { data } = await api.get<ConsultationReimbursementReport | null>(
    getReimbursementReportUrl(consultationId),
  );

  return data;
};

export const updateReimbursementReport = async (
  reportData: { data: ReimbursementReportData },
  consultationId?: string,
) => {
  const { data } = await api.put<ConsultationReimbursementReport>(
    getReimbursementReportUrl(consultationId),
    reportData,
  );
  return data;
};

export const completeReimbursementReport = async (
  reportData: { data: ReimbursementReportData },
  consultationId?: string,
) => {
  const { data } = await api.post<ConsultationReimbursementReport>(
    `${getReimbursementReportUrl(consultationId)}/complete`,
    reportData,
  );
  return data;
};
